export type LeaveType = 'ANNUAL' | 'HALF' | 'SICK' | 'TRIP' | 'OTHER';
export type LeaveStatus = 'DRAFT' | 'APPROVED' | 'CANCELLED' | string;
export type HalfDayPeriod = 'AM' | 'PM';

export interface LeaveRequest {
  leaveRequestId: number;
  leaveType: LeaveType | string;
  startDate: string;
  endDate: string;
  days: number;
  halfDayPeriod?: HalfDayPeriod | string | null;
  reason?: string | null;
  status: LeaveStatus;
  balanceApplied?: boolean | null;
  requesterUserId?: number | null;
  requesterName?: string | null;
  approverUserId?: number | null;
  approverName?: string | null;
  approvalInProgress?: boolean | null;
  pendingApprovalRequestId?: number | null;
  canCancelApproval?: boolean | null;
  canEdit?: boolean | null;
  canDelete?: boolean | null;
  canRequestApproval?: boolean | null;
  canApproveDirect?: boolean | null;
  canRevoke?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface LeaveRequestPayload {
  leaveType: LeaveType | string;
  startDate: string;
  endDate: string;
  days?: number | null;
  halfDayPeriod?: HalfDayPeriod | string | null;
  reason?: string | null;
}

export interface LeaveBalance {
  balanceId?: number | null;
  userId: number;
  userName?: string | null;
  leaveYear: number;
  grantedDays: number;
  carriedInDays: number;
  usedDays: number;
  remainingDays: number;
  suggestedGrantedDays?: number | null;
  suggestedGrantExplain?: string | null;
  remark?: string | null;
  canEdit?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface LeaveBalanceUpsertPayload {
  userId: number;
  leaveYear: number;
  /** 부여 일수 증감분 (+ 추가 / - 차감) */
  adjustGrantedDays: number;
  /** 최종 부여 일수(절대값). 구버전 API 호환용 */
  grantedDays?: number;
  /** 부여/조정 사유 (필수) */
  remark: string;
}

export const LEAVE_TYPE_OPTIONS: { value: LeaveType; label: string }[] = [
  { value: 'ANNUAL', label: '연차' },
  { value: 'HALF', label: '반차' },
  { value: 'SICK', label: '병가' },
  { value: 'TRIP', label: '출장' },
  { value: 'OTHER', label: '기타' },
];

export function leaveTypeLabel(type?: string | null) {
  return LEAVE_TYPE_OPTIONS.find((item) => item.value === type)?.label || type || '-';
}

export function leaveStatusLabel(status?: string | null, approvalInProgress?: boolean | null) {
  if (approvalInProgress) return '결재 요청 중';
  switch (status) {
    case 'DRAFT':
      return '작성중';
    case 'APPROVED':
      return '승인';
    case 'CANCELLED':
      return '취소';
    default:
      return status || '-';
  }
}

export function leaveStatusClass(status?: string | null, approvalInProgress?: boolean | null) {
  if (approvalInProgress) return 'pending';
  return (status || '').toLowerCase();
}

export function halfDayPeriodLabel(period?: string | null) {
  switch ((period || '').toUpperCase()) {
    case 'AM':
      return '오전';
    case 'PM':
      return '오후';
    default:
      return period || '-';
  }
}

export function consumesLeaveBalance(type?: string | null) {
  const t = (type || '').toUpperCase();
  return t === 'ANNUAL' || t === 'HALF';
}

export function formatLeaveDays(value?: number | null) {
  if (value == null || Number.isNaN(Number(value))) return '0';
  const n = Number(value);
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}
